angular.module('authenticationServices')
    .controller("authenticationServicesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'Upload',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, Upload) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("AUTHENTICATION_SERVICES_WRITE");
            $rootScope.title = $filter('translate')('authentication-services.title');

            $scope.authentication_service = {};
            $scope.showImg = "";

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('authentication-services.title'), url: "authentication-services.list" },
                    { title: $filter('translate')('authentication-services.title_add') },
                ];
            } else {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('authentication-services.title'), url: "authentication-services.list" },
                    { title: $filter('translate')('authentication-services.title_edit') },
                ];
                Restangular.one('AuthenticationServices', $stateParams.id).get().then(function (result) {
                    $scope.authentication_service = result;
                });
                Restangular.all('Files').getList({ entity_type: 'authentication_services', entity_type_id: $stateParams.id }).then(function (result) {

                    result ? $scope.logo = result[0] : "";
                   
                    if ($scope.logo != null) {
                        Restangular.one(`Files/${$scope.logo.uid}/download/b64`).get().then(function (result) {
                            $scope.showImg = `data:image/jpeg;base64,${result}`;
                        })
                    }

                });

            }
            $scope.selectImage = function () {
                $("#frmImage").trigger("click");
                $("#frmImage").change(function () {
                    const fileInput = document.querySelector('#frmImage') as HTMLInputElement;
                    const file = fileInput?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            const src = (event.target as FileReader).result;
                            $scope.showImg = src;
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                        $scope.file = file; 
                    } else {
                        //preview.src = "";
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.showImg && $scope.showImg != "" ) {
                    return $scope.showImg;
                }  else {
                    return "assets/img/no-image.png";
                }
            };

            $scope.removeImage = function ($event) {
                $event.stopPropagation();
                $scope.showImg = null;
                $scope.file = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };
          let uploadFile = function (id) {
                    $scope.file.upload = Upload.upload({
                        url: (window as any).CONFIG.api_url + "Files/uploadFile",
                        data: { file: $scope.file, id: 0, entity_type: "authentication_services", entity_type_id: id, is_public: "true"},
                    });
                    $scope.file.upload.then(function (response) {
                    }, function (response) {
                        if (response.status > 0) {
                            let errorMsg = response.status + ': ' + response.data;
                            toastr.error("Ha ocurrido un error: " + errorMsg);
                        }
                    });
          }

            let manageFile = function (id) {
                if ($scope.file) { uploadFile(id) };
                if ($scope.logo && ($scope.file || !$scope.showImg)) {$scope.logo.remove() }
                      
            }
        $scope.saveAuthenticationService = function () {
            if (angular.isDefined($scope.authentication_service.id)) {
                $scope.authentication_service.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        manageFile(result.id);
                        toastr.success($filter('translate')('authentication-services.edit_success'));
                        $state.go("authentication_services.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('AuthenticationServices').post($scope.authentication_service).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        manageFile(result.id);
                        toastr.success($filter('translate')('authentication-services.save_success'));
                        $state.go("authentication_services.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('authentication-services.button_delete'),
                message: $filter('translate')('authentication-services.delete_message') + " " + $scope.authentication_service.name + "?",
                onAccept: function () {
                       if ($scope.logo) { $scope.logo.remove() };
                       $scope.authentication_service.remove().then(function () {
                        toastr.success($filter('translate')('authentication-services.deleted_success'));
                        $state.go("authentication_services.list");
                    });
                }
            });
            };

    }]);